import Vue from 'vue';
import VueI18n from 'vue-i18n';
import bg from './bg';
import en from './en';
import languages from '../enums/languages';

Vue.use(VueI18n);

export default new VueI18n({
  locale: localStorage.getItem('lang') || languages.en,
  messages: {
    bg,
    en
  }
});
